import { call, put, takeLatest } from 'redux-saga/effects'
import { checkLogin } from '../../pages/Login/reducer'
import { getCookie, setCookie } from './helpers'

import { push } from '@lagunovsky/redux-react-router'
import { callApiAsync } from 'services/api/callAPIAsync'
import { getToken, setLoading } from './reducer'

function* isTokenValid() {
    const token = getCookie('token')
    if (!token) {
        return false
    }

    const { error } = yield call(callApiAsync, 'getTokenInfo')

    return error === null
}

// Cookie is the main source of token data, local storage is just for convenience.
// Local storage could and probably should be replaced by redux state.

function* tokenCallSaga() {
    yield put(setLoading(true))

    const havingValidToken = yield isTokenValid()

    const cookieToken = getCookie('token')
    const cookieTokenValidity = getCookie('token_validity')

    //if Valid token from previous visit of page
    if (havingValidToken) {
        localStorage.setItem('token', cookieToken)
        localStorage.setItem('token_validity', cookieTokenValidity)
        yield put(checkLogin())
        yield put(setLoading(false))
        return null
    }

    //if no Valid token from previous visit of page
    const { data: tokenData, error: tokenError } = yield call(callApiAsync, 'createToken')

    if (tokenError) {
        console.error(tokenError)
        yield put(setLoading(false))
        yield put(push('/error'))
        return null
    }

    yield localStorage.setItem('token', tokenData.token)
    yield setCookie('token', tokenData.token)

    yield localStorage.setItem('token_validity', tokenData.validity)
    yield setCookie('token_validity', tokenData.validity)

    yield put(setLoading(false))
    yield put(checkLogin())
}

export default function* tokenSaga() {
    yield takeLatest(getToken.type, tokenCallSaga)
}
